import React, {useEffect, useState} from 'react';
import dxDataGrid from 'devextreme/ui/data_grid';
import styles from './index.module.scss';
import { Utilities, Dictionary } from '@utils';

interface ITableErrorsProps{
    calculatedResume?(item: any, table: any): boolean;
    checkResumePlanning?(table: any): boolean;
	calculatedSumMonth?(item: any): boolean;
    calculatedReqFields?(item: any): boolean;
    changeStyles?(parentGrid: dxDataGrid): void;
    checkFinancialValues?(item: any): boolean;
    initialValidate?: boolean;
    gridId: string;
    tableAlert: string;
    followupLabels: Dictionary<string, string>;
    msgInitialError?: string;
    section?: string;
}

const FinancialError: React.FC<ITableErrorsProps> = ({calculatedResume, calculatedSumMonth, changeStyles, calculatedReqFields, checkFinancialValues, checkResumePlanning,
    gridId, tableAlert, followupLabels, initialValidate, msgInitialError, section}: ITableErrorsProps) => {
    const [parentGrid, setParentGrid] = useState<dxDataGrid>();    
    const [error, setError] = useState(null);

    const validateGridDataErrors = (data:any) => {
        let isError = false;
        let firstError: string = null;
        if(data[0] !== undefined){
            if((tableAlert === gridId || tableAlert === 'All') || (error && !Utilities.isNullEmptyObject(tableAlert))){
                data.forEach((item:any, index: number) => {  
                    if(parentGrid !== undefined){  
                        const rowElements = parentGrid.getRowElement(index);
                        if(rowElements !== undefined){
                            let errorName: string = 'noError'
                            let hasError = (calculatedResume  && ![2, 3].includes(index)) ? calculatedResume(item, data) : false
                            let sumMonth = calculatedSumMonth ? calculatedSumMonth(item) : false
                            let ReqFields = calculatedReqFields ? !calculatedReqFields(item) : false

                            if(hasError && !isError) setError(followupLabels.get("alertBudgetTotals") );
                            else if(sumMonth && !isError) setError(followupLabels.get("alertMonthsPlanYearBudget"));
                            else if(ReqFields && !isError) setError(followupLabels.get("alertRequiredFields"));

                            errorName = hasError ? 'hasError' : (sumMonth) ? 'sumMonth' : (ReqFields) ? 'ReqFields' : 'noError'

                            if((sumMonth || hasError || ReqFields)){                     
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.add(styles.tdError);
                                });
                                isError = true;
                                firstError = errorName;
                            }else{
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.remove(styles.tdError);
                                });
                            }
                        }
                    }    
                    changeStyles?.(parentGrid)
                });
                if(!isError) setError(null)
            }
        }  
    }

    const validateInitialValue = (data:any) => {
        let isError = false;
        if(data[0] !== undefined){
            if(initialValidate){
                data.forEach((item:any, index: number) => {  
                    if(parentGrid !== undefined){  
                        const rowElements = parentGrid.getRowElement(index);
                        if(rowElements !== undefined){
                            let emptyValues = checkFinancialValues?.(item)
                            let resumeData = (index < 2) ? checkResumePlanning?.(data) : false

                            if(emptyValues && !isError) setError(msgInitialError);
                            else if(resumeData && !isError) setError(followupLabels.get("alertResumePOP"));

                            if(emptyValues || resumeData){                        
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.add(styles.tdError);
                                });
                                isError = true;
                            }else{
                                rowElements[0].childNodes.forEach((child:any) => {  
                                    child.classList.remove(styles.tdError);
                                });
                            }
                        }
                    }    
                          
                });
                if(!isError) setError(null)
            }
            changeStyles?.(parentGrid)  
        }  
    }

    useEffect(()=>{        
        if(parentGrid !== undefined){
            parentGrid.option("onContentReady",(data:any) => {
                validateGridDataErrors(data.component.getDataSource().items())
            });
            parentGrid.option("onOptionChanged", (data: any ) => {
                if(data.name === "dataSource"){
                    validateGridDataErrors(data);
                }
            })
        }
        // eslint-disable-next-line
    },[parentGrid, tableAlert, initialValidate]);

    useEffect(()=>{        
        if(parentGrid !== undefined){
            parentGrid.option("onContentReady",(data:any) => {
                validateInitialValue(data.component.getDataSource().items())
            });
        }
        // eslint-disable-next-line
    },[parentGrid, initialValidate]);

    useEffect(()=>{
        if(gridId  !== undefined){
            const container = document.getElementById(gridId) as HTMLElement;
            const instance = dxDataGrid.getInstance(container) as dxDataGrid;
            setParentGrid(instance)
        }
    },[gridId])

    useEffect(()=>{
        if(Utilities.isNullEmptyObject(tableAlert)){
            setError(null)
        }
    },[tableAlert])
    
    return (
        <>
            <div style={{width:"100%", textAlign:"center"}}>
                <h6 style={{color:"red", padding:"1rem 1rem 0"}}>{error || ''}</h6>
            </div>
        </>
    )
}

export default FinancialError;